module.exports = __webpack_public_path__ + "img/reviews-image5.2523b2b1.jpg";